var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressureHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4189 23.4318C29.9531 21.0788 30.8447 18.2685 30.8447 15.25C30.8447 12.0791 29.8608 9.13805 28.1817 6.71541L26.7248 8.63912C27.915 10.5784 28.6013 12.8603 28.6013 15.3025C28.6013 17.7571 27.9081 20.0497 26.7067 21.9953H4.98281C3.78144 20.0497 3.0882 17.7571 3.0882 15.3025C3.0882 8.25727 8.7995 2.54596 15.8448 2.54596C18.4949 2.54596 20.9562 3.35407 22.9959 4.73732L24.9061 3.29526C22.3887 1.38416 19.2492 0.25 15.8447 0.25C7.56046 0.25 0.844727 6.96573 0.844727 15.25C0.844727 18.2685 1.73633 21.0788 3.27055 23.4318C3.6141 23.9587 4.21372 24.25 4.84273 24.25H26.8467C27.4757 24.25 28.0754 23.9587 28.4189 23.4318Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1036 17.9449C16.8561 19.1924 14.8334 19.1924 13.5858 17.9449C12.3383 16.6973 12.3383 14.6746 13.5858 13.4271C14.8334 12.1795 26.5889 4.94177 26.5889 4.94177C26.5889 4.94177 19.3512 16.6973 18.1036 17.9449Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureHigh);
export default __webpack_public_path__ + "static/media/pressure_high.e81d8cecee4db29a866ae8da86fee7f9.svg";
export { ForwardRef as ReactComponent };